module.exports = __webpack_public_path__ + "img/GD.43bd76c4.png";